import { uniqBy } from "lodash";
import moment from "moment";
import { AppConstants } from "../../common/APIConstants";

// Sort resoucres
export const sortResources = (data) => {
  if (data.length > 0) {
    data = data.sort((currItem, nextItem) => {
      if (currItem.label < nextItem.label) { return -1; }
      if (currItem.label > nextItem.label) { return 1; }
      return 0
    })
  }

  return data
}

/** Take out distict and sorted divisions, districts, & assets based on 
 * - Both Regions: North & South
 * - OR only South
 * - OR only North
 * 
 * resources: {
 *  selectedRegn,
 *  selectedDiv,
 *  selectedDist
 * }
 * 
 * dropdownFlag - indicates which dropdown got touched
*/
export const getCorrespondingResources = (gridMainData, resources, dropdownFlag) => {
  const {
    selectedRegn,
    selectedDiv,
    selectedDist
  } = resources

  let divs = []
  let dists = []
  let assets = []

  if(dropdownFlag === 'Region' && selectedRegn?.value === '*'){
    const divs = getAllUniqDivisions(gridMainData)
    const dists = getAllUniqDistricts(gridMainData)
    const assets = getAllUniqAssets(gridMainData)

    return { divs, dists, assets }
  }
    if (dropdownFlag === 'Division' && selectedDiv?.value === '*') {
        const dists = getAllUniqDistrictsFilterByRegion(gridMainData, selectedRegn)
        const assets = getAllUniqAssetsFilterByRegionAndDistrict(gridMainData, selectedRegn, dists)

    return { dists, assets }
  }
  if(dropdownFlag === 'District' && selectedDist?.value === '*'){
      const assets = getAllUniqAssetsByRegionAndDistrict(gridMainData, selectedRegn, selectedDiv)

    return { assets }
  }

  if(dropdownFlag === 'Region' && selectedRegn?.value !== '*'){
    const regionLabels = selectedRegn.map(item => item.label)
    divs = getCorrespondingDivisions(gridMainData, regionLabels)
    const divisionLabels = divs.map(item => item.label)
    dists = getCorrespondingDistricts(gridMainData, regionLabels, divisionLabels)
    const districtLabels = dists.map(item => item.label)
    assets = getCorrespondingAssets(gridMainData, regionLabels, divisionLabels, districtLabels)

    return { divs, dists, assets }
  }

  if(dropdownFlag === 'Division' && selectedDiv?.value !== '*'){
    const regionLabels = selectedRegn.map(item => item.label)
    const divisionLabels = selectedDiv.map(item => item.label)
    dists = getCorrespondingDistricts(gridMainData, regionLabels, divisionLabels)
    const districtLabels = dists.map(item => item.label)
    assets = getCorrespondingAssets(gridMainData, regionLabels, divisionLabels, districtLabels)
  
    return { dists, assets }
  }
  if(dropdownFlag === 'District' && selectedDist?.value !== '*'){
    const regionLabels = selectedRegn.map(item => item.label)
    const divisionLabels = selectedDiv.map(item => item.label)
    const districtLabels = selectedDist.map(item => item.label)
    assets = getCorrespondingAssets(gridMainData, regionLabels, divisionLabels, districtLabels)
  
    return { assets }
  }

  return { divs, dists, assets } 
}

export const getAllUniqDivisions = (gridMainData) => {
  let divs = [...new Set(gridMainData.map(item => {
    if (typeof item.Division != 'undefined') return item.Division
  }))].filter(b => { return b != null });
  let divisions = divs.map(f => ({ label: f, value: f }));
  divisions = sortResources(divisions)

  divisions.push({label: 'Blank', value: null})
  //divisions.push({label: 'Null', value: null})

  return divisions
}

export const getAllUniqDivisionsFilterByRegion = (gridMainData, region) => {
    let divs = [...new Set(gridMainData.map(item => {
        if (typeof item.Division != 'undefined' && region.some(i => i.value?.trim() === item.Region?.trim())) {
            return item.Division
        }
    }))].filter(b => { return b != null });
    let divisions = divs.map(f => ({ label: f, value: f }));
    divisions = sortResources(divisions)

    divisions.push({ label: 'Blank', value: null })
    //divisions.push({label: 'Null', value: null})

    return divisions
}

export const getAllUniqDistrictsFilterByRegionAndDivision = (gridMainData, region, division) => {
    let dist = [...new Set(gridMainData.map(item => {
        if (typeof item.District != 'undefined' &&
            region.some(i => i.value?.trim() === item.Region?.trim()) &&
            division.some(i => i.value?.trim() === item.Division?.trim())) {
            return item.District
        }
    }))].filter(b => { return b != null });
    let districts = dist.flatMap(e => e.split('; ')).map(q => ({ label: q, value: q }));
    districts = uniqBy(districts, 'value');
    districts = sortResources(districts)

    districts.push({ label: 'Blank', value: null })
    //districts.push({label: 'Null', value: null})

    return districts
}

export const getAllUniqDistricts = (gridMainData) => {
  let dist = [...new Set(gridMainData.map(item => {
    if (typeof item.District != 'undefined') return item.District
  }))].filter(b => { return b != null });
  let districts = dist.flatMap(e => e.split('; ')).map(q => ({ label: q, value: q }));
  districts = uniqBy(districts, 'value');
  districts = sortResources(districts)

  districts.push({label: 'Blank', value: null})
  //districts.push({label: 'Null', value: null})

  return districts
}

export const getAllUniqDistrictsFilterByRegion = (gridMainData, region) => {
    let dist = [...new Set(gridMainData.map(item => {
        if (typeof item.District != 'undefined' && region.some(i => i.value?.trim() === item.Region?.trim())) {
            return item.District
        }
    }))].filter(b => { return b != null });
    
    let districts = dist.flatMap(e => e.split('; ')).map(q => ({ label: q, value: q }));
    districts = uniqBy(districts, 'value');
    districts = sortResources(districts)

    districts.push({ label: 'Blank', value: null })
    //districts.push({label: 'Null', value: null})

    return districts
}

export const getAllUniqAssetsFilterByRegionAndDistrict = (gridMainData, region, district) => {
    
    let facility = [...new Set(gridMainData.map(item => {
        if (typeof item.Facility != 'undefined' &&
            region.some(i => i.value?.trim() === item.Region?.trim()) &&
            item?.District &&
            item?.District.split(';').some(d => district.some(dt => dt.value?.trim() === d?.trim()))
        ) {
            return item.Facility
        }
    }))].filter(b => { return b != null });
    let assets = facility.flatMap(e => e.split('; ')).map(f => ({ label: f, value: f }));
    assets = uniqBy(assets, 'value')
    assets = sortResources(assets)

    assets.push({ label: 'Blank', value: null })
    //assets.push({label: 'Null', value: null})

    return assets
}


export const getAllUniqAssetsFilterByRegionDivisionAndDistrict = (gridMainData, region, division, district) => {

    let facility = [...new Set(gridMainData.map(item => {
        if (typeof item.Facility != 'undefined' &&
            region.some(i => i.value?.trim() === item.Region?.trim()) &&
            division?.some(i => i.value?.trim() === item.Division?.trim()) &&
            item?.District && item?.District.split(';').some(d => district.some(dt => dt.value?.trim() === d?.trim()))
        ) {
            return item.Facility
        }
    }))].filter(b => { return b != null });
    let assets = facility.flatMap(e => e.split('; ')).map(f => ({ label: f, value: f }));
    assets = uniqBy(assets, 'value')
    assets = sortResources(assets)

    assets.push({ label: 'Blank', value: null })
    //assets.push({label: 'Null', value: null})

    return assets
}

export const getAllUniqAssetsByRegionAndDistrict = (gridMainData, region, division) => {
    debugger;
    let facility = [...new Set(gridMainData.map(item => {
        if (typeof item.Facility != 'undefined' &&
            region.some(i => i.value?.trim() === item.Region?.trim()) && item.Division &&
            division?.some(i => i.value?.trim() === item.Division?.trim()))
        {
            return item.Facility
        }
    }))].filter(b => { return b != null });
    let assets = facility.flatMap(e => e.split('; ')).map(f => ({ label: f, value: f }));
    assets = uniqBy(assets, 'value')
    assets = sortResources(assets)

    assets.push({ label: 'Blank', value: null })
    //assets.push({label: 'Null', value: null})

    return assets
}

export const getAllUniqAssets = (gridMainData) => {
  let facility = [...new Set(gridMainData.map(item => {
    if (typeof item.Facility != 'undefined') return item.Facility
  }))].filter(b => { return b != null });
  let assets = facility.flatMap(e => e.split('; ')).map(f => ({ label: f, value: f }));
  assets = uniqBy(assets, 'value')
  assets = sortResources(assets)

  assets.push({label: 'Blank', value: null})
  //assets.push({label: 'Null', value: null})

  return assets
}

const getCorrespondingDivisions = (gridMainData, regionLabels) => {
  let divs = gridMainData.reduce((acc, curr) => {
    if(regionLabels.includes(curr.Region) && typeof curr.Division!== 'undefined' 
      && acc?.length === 0){
      acc.push(curr.Division)
    }
    if(regionLabels.includes(curr.Region) && typeof curr.Division!== 'undefined' 
    && !acc.includes(curr?.Division) && acc?.length !== 0){
      acc.push(curr.Division)
    }
    return acc
  }, []).filter(div => {return div !== null}).map(f => ({ label: f, value: f }))

  divs = uniqBy(divs, 'value')
  divs = sortResources(divs)

  divs.push({label: 'Blank', value: null})
  //divs.push({label: 'Null', value: null})

  return divs
}

const getCorrespondingDistricts = (gridMainData, regionLabels, divisionLabels) => {
  const dist = [...new Set(gridMainData.map(item => {
    if (typeof item.District != 'undefined' && regionLabels.includes(item.Region) && 
    divisionLabels.includes(item.Division)){ return item.District}
  }))].filter(b => { return b != null });

  let districts = dist.flatMap(e => e.split('; ')).map(item => ({label: item, value: item}))
  districts = uniqBy(districts, 'value')
  districts = sortResources(districts)
  districts.push({label: 'Blank', value: null})
 //districts.push({label: 'Null', value: null})

  return districts
}

const getCorrespondingAssets = (gridMainData, regionLabels, divisionLabels, districtLabels) => {
    let distCheck = []

    let gridData = [...gridMainData.filter(item => divisionLabels.includes(item.Division))]

    let facility = [...new Set(gridData.map(item => {

    // In gridMainData, District is comma separated thus, split it and match with districtLabels
    if(item?.District &&  districtLabels){
      let dists = item.District.split('; ')
      if(dists?.length === 0){
        dists = [item.District]
      }
      distCheck = districtLabels.filter(item => dists.some(ele => item === ele))
    }

      if (typeof item.Facility != 'undefined' && regionLabels.includes(item.Region) &&
          divisionLabels.includes(item.Division) && distCheck.length != 0) { 
        return item.Facility
    }}))].filter(b => { return b != null })

  let assets = facility.flatMap(e => e.split('; ')).map(f => ({ label: f, value: f }));
  assets = uniqBy(assets, 'value')
  assets = sortResources(assets)
  assets.push({label: 'Blank', value: null})
  //assets.push({label: 'Null', value: null})

  return assets
}

export const getActiveResources = (data, fieldName) => {
  let resource = []
    switch(fieldName){
      case 'Region':
        resource = uniqBy([...data].map(item => {
          let region = null
          if(item.IsActive){
            if(item.Region === 'N'){ region = 'Plains - North'}
            if(item.Region === 'S'){ region = 'Plains - South'}
          }
          return region
        }))
      break
      case 'Division':
        resource = uniqBy([...data].map(item => {
          if(item.IsActive){return item.Division}
        }))
      break
      case 'District':
        resource = uniqBy([...data].map(item => {
          if(item.IsActive){return item.DistrictNm}
        }))
      break
      case 'Asset':
        resource = uniqBy([...data].map(item => {
          if(item.IsActive){return item.FacilityNm}
        }))
      break
      default:
        break
    }
  return resource
}

const removeOffset = (dateTime) => {
  let formDate

  // Remove postive/negative offset
  if(dateTime){
    if(dateTime.includes("+")){
      formDate = moment(dateTime).format().split("+")[0]
      return dateTime = formDate
    }else{
      const newDateTime = moment(dateTime).format().split(":")
      const seconds = newDateTime[2].split("-")[0]
      formDate = `${newDateTime[0]}:${newDateTime[1]}:${seconds}`
      dateTime = formDate
    }
  }
  return formDate
}

export const getDateTimeWithoutUTCOffset = (dateTime, fieldName) => {
  if(dateTime){
    dateTime = moment(dateTime).format()

    if(fieldName === 'StartDate'){
      dateTime = removeOffset(dateTime)
    }
    if(fieldName === 'EndDate'){
      dateTime = removeOffset(dateTime)
    }
    if(fieldName === 'CCRestartDate'){
      dateTime = removeOffset(dateTime)
    }
  }

  return dateTime
}

export const getRegionBasedDateTime = (dateTime, region) => {
  const { CST_TIME_FORMATTER, MT_TIME_FORMATTER } = AppConstants
  const timeZone = ['Plains - South', ''].includes(region) ? CST_TIME_FORMATTER : MT_TIME_FORMATTER

  if(dateTime){
    return new Date(moment.utc(moment(dateTime)).tz(timeZone).format("YYYY-MM-DD HH:mm:ss"))
  }
  
  return null
}

export const getDateInCSTOrMST = (dateTime, region) => {
    const { CST_TIME_FORMATTER, MT_TIME_FORMATTER } = AppConstants
    const timeZone = ['Plains - South', ''].includes(region) ? CST_TIME_FORMATTER : MT_TIME_FORMATTER

    const utcDate = moment.utc(dateTime);

    const cstDate = utcDate.tz(timeZone);

    const formattedDate = cstDate.format("YYYY-MM-DD HH:mm:ss");

    const resultDate = new Date(formattedDate);

    return `${moment(resultDate).format('MM/DD/YYYY h:mm a')} ${['Plains - South', ''].includes(region) ? 'CST' : 'MST'}`;
}